export class HttpCancelError extends Error {};
